import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const getAxiosStreamOwner = async (name) => {
  try {
    const { accessToken } = store.state.app.user
    const headers = {
      Authorization: `Bearer ${accessToken}`
    }
    const { data } = await axios.get(`${API_URL.FULLNAME}/${name}`, { headers })
    return data
  } catch (e) {
    console.log(e.response?.data)
  }
  return ''
}
